export default __webpack_public_path__ + "static/image-offline-bc22259a3a4476feff08b0e4ce835168.jpg";